// extracted by mini-css-extract-plugin
export default {"icon":"no-deals-message-module__icon___a4f0o","button":"no-deals-message-module__button___eW3XR"};